import { ExternalLinkIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router';

import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';
import { Button, buttonVariants } from '@/components/ui/button';
import { useBrainId } from '@/hooks/useBrainId';
import { selectAccountSlug } from '@/redux/session/selectors';

type DisableToolWarningDialogProps = {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  onViewGuideline?: () => void;
};

export const DisableToolWarningDialog = ({
  open,
  onClose,
  onConfirm,
  onViewGuideline,
}: DisableToolWarningDialogProps) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const brainId = useBrainId();
  const slug = useSelector(selectAccountSlug);

  return (
    <AlertDialog open={open} onOpenChange={(isOpen) => !isOpen && onClose()}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>
            {t('local_tools.disable_tool_guideline_warning_title')}
          </AlertDialogTitle>
          <AlertDialogDescription>
            {t('local_tools.disable_tool_guideline_warning_description')}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <Button
          variant="link"
          className="h-auto w-fit p-0"
          onClick={() => {
            onClose();
            onViewGuideline?.();
            navigate(`/${slug}/ai-agents/${brainId}/guidelines`);
          }}
        >
          {t('local_tools.view_guideline')}
          <ExternalLinkIcon />
        </Button>
        <AlertDialogFooter>
          <AlertDialogCancel>{t('common.cancel')}</AlertDialogCancel>
          <AlertDialogAction
            className={buttonVariants({ variant: 'destructive' })}
            onClick={onConfirm}
          >
            {t('common.disable')}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
